// components
import { Box, Typography } from '@mui/material';
import { Icon } from '@sdb/planning-ui';

// hooks
import { useTranslation } from 'react-i18next';

// styles
import { IconContainer } from 'components/shared/Header/Header.styles';
import {
  StyledNoAccessInnerBox,
  StyledNoAccessMainBox
} from './NoAccessPage.styles';

// utils
import theme from 'config/theme';

const NoAccessPage = () => {
  const { t } = useTranslation('common', {
    keyPrefix: 'noAccessPage'
  });

  return (
    <StyledNoAccessMainBox>
      <StyledNoAccessInnerBox>
        <Box>
          <IconContainer
            iconSize="LARGE"
            iconColor={theme.palette.primary.main}
          >
            <Icon type="box-open" fontSize="large" color="inherit" />
          </IconContainer>
        </Box>
        <Typography component="h4" variant="h4">
          {t('title')}
        </Typography>
        <Typography component="p" variant="body1">
          {t('description')}
        </Typography>
      </StyledNoAccessInnerBox>
    </StyledNoAccessMainBox>
  );
};

export default NoAccessPage;
